import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./styles/banner.css";
import fetchFlag from "../../utils/featureFlags";
import { fetchPaxBalance } from "../../utils/paxHelpers";

export default function Banner({
  onToggleMenu,
  onOpenPax,
  canShowStripe,
  allowTopUp,
  canShowBalance,
  onAddFunds,
}) {
  const [logoURL, setLogoURL] = useState("");
  const [displayName, setDisplayName] = useState("Missing Display Name!");
  const [menuOpen, setMenuOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const { guid } = useParams();
  const navigate = useNavigate();
  const userMenuRef = useRef(null);
  const [paxData, setPaxData] = useState([]);

  const [balance, setBalance] = useState(null);
  const [showBalance, setShowBalance] = useState(true);
  const shouldShowBalance =
  canShowBalance && showBalance && balance !== null;

  // Load client logo
  useEffect(() => {
    const storedClientData = localStorage.getItem("clientData");
    if (storedClientData) {
      const clientData = JSON.parse(storedClientData);
      if (clientData.BannerLogoURL) setLogoURL(clientData.BannerLogoURL);
    }
  }, []);

  // Load pax data
  useEffect(() => {
    const loadFlagsAndPax = async () => {
      const storedPaxData = localStorage.getItem("paxData");
      let paxOnAccount = 0;

      if (storedPaxData) {
        const parsed = JSON.parse(storedPaxData);
        setPaxData(parsed);

        if (parsed[0]) {
          setDisplayName(
            `${parsed[0].Title} ${parsed[0].Forename} ${parsed[0].Surname}`
          );
          fetchPaxBalance(guid, parsed[0].PaxId).then((bal) => setBalance(bal));
          
          paxOnAccount = parsed[0].OnAccount;
        }
      }
    };

    loadFlagsAndPax();
  }, [guid]);

  // Close menus when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target))
        setUserMenuOpen(false);
      if (!e.target.closest(".side-menu") && !e.target.closest(".banner__side"))
        setMenuOpen(false);
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <header className="banner">
      <div className="banner__side">
        <button
          className="iconbtn"
          aria-label="Open menu"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
      </div>

      <div className="brand">
        {logoURL ? (
          <img src={logoURL} alt="Logo" />
        ) : (
          <img src="https://placehold.co/160x40/png" alt="Logo" />
        )}
      </div>

      <div className="banner__side relative" ref={userMenuRef}>
        {shouldShowBalance && (
          <div className="balance-text">
            <span
              className="balance-full"
              style={{
                color: balance > 0 ? "green" : balance < 0 ? "red" : "black",
              }}
            >
              Account Balance: £{Number(balance).toFixed(2)}
            </span>
          </div>
        )}

        <button
          className="iconbtn"
          aria-label="User"
          onClick={(e) => {
            e.stopPropagation();
            setUserMenuOpen((prev) => !prev);
          }}
        >
          <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M20 21a8 8 0 1 0-16 0" />
            <circle cx="12" cy="7" r="4" />
          </svg>
        </button>

        {userMenuOpen && (
          <div className="user-menu-dropdown">
            <div className="user-menu-item username">{displayName}</div>
            <div
              className="user-menu-item"
              onClick={() => {
                if (paxData.length && onOpenPax) {
                  onOpenPax(paxData[0]);
                  setUserMenuOpen(false);
                }
              }}
            >
              Profile
            </div>
            <div
              className="user-menu-item"
              onClick={() => {
                localStorage.removeItem("paxData");
                navigate(`/${guid}/`);
              }}
            >
              Logout
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
